export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const STRUCTURE_CHANGE = 'STRUCTURE_CHANGE';
export const UPDATED_PROFILE = 'UPDATED_PROFILE';


